import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ActiveconfirmPage } from './activeconfirm';

@NgModule({
  declarations: [
    ActiveconfirmPage,
  ],
  imports: [
    IonicPageModule.forChild(ActiveconfirmPage),
  ],
})
export class ActiveconfirmPageModule {}



// WEBPACK FOOTER //
// ./src/pages/activeconfirm/activeconfirm.module.ts